<template>
  <div class="row">
    <div class="col-md-12">
      <label>DATA</label>
      <input type="date" class="form-control" v-model="date" />
    </div>

    <div class="col-md-12">
      <label>TIPO DE INTERCORRÊNCIA</label>
      <select class="form-control" v-model="type">
        <option value="">SELECIONE...</option>
        <option value="QUEDA">QUEDA</option>
        <option value="INTERNACAO">INTERNAÇÃO</option>
        <option value="INFECCAO">INFECÇÃO</option>
        <option value="ACOMPANHADO_PROBLEMA_SAUDE">
          ACOMPANHADO POR PROBLEMA SAÚDE
        </option>
      </select>
    </div>

    <div class="col-md-12">
      <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="text" />
    </div>

    <div class="col-md-12">
      <ErrorsMessages :errors="errors" />
    </div>

    <div class="col-md-12 check-text-right">
      <confirmation-dialog
        headerClass="modal-header"
        message-title="SALVAR?"
        :message-body="`Deseja realmente salvar?`"
        open-text="SALVAR"
        open-class="btn-modern btn-modern-add"
        open-left-icon="fa-check"
        @yes="create()"
        :loading="loading"
        :disabled="loading"
      />
    </div>
  </div>
</template>

<script>
import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Create",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      date: moment().format("YYYY-MM-DD"),
      type: "",
      text: "",
      loading: false,
      errors: [],
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        const { resident_id, date, type, text } = this;

        let params = {
          resident_id,
          date,
          type,
          text,
        };

        const response = await api.post(
          "/rest-home/resident/dashboard/monitored-health-problems",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("modalCreate");
          this.$emit("success");
          this.type = "";
          this.text = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>